// import { createColumnHelper } from '@tanstack/react-table'
// import { changeValueFormat } from './format.utils'

// const columnHelper = createColumnHelper()

// /*
//  * this function is used to generate the headers
//  * @props
//  * data: contains the array of object with the keys of [name, key, type]
//  */
// export const generateReportHeaders = (data, moduleType) => {
//   return data
//     ?.filter(item => !item?.hidden)
//     ?.map(item => {
//       // console.log('>>>', item, item?.field)
//       return columnHelper.accessor(item?.field, {
//         header: ({ table }) => (
//           <p
//             style={{
//               textAlign:
//                 moduleType === 'report' &&
//                 table.options.data?.some(
//                   i => typeof i?.[item?.field] == 'number'
//                 )
//                   ? 'right'
//                   : 'left',
//               width:
//                 moduleType === 'report' &&
//                 table.options.data?.some(
//                   i => typeof i?.[item?.field] == 'number'
//                 ) &&
//                 100,
//               whiteSpace:
//                 moduleType === 'report' &&
//                 table.options.data?.some(
//                   i => typeof i?.[item?.field] == 'number'
//                 ) &&
//                 'wrap'
//             }}
//           >
//             {/* {console.log(
//               table.options.data?.some(i => typeof i?.[item?.field] == 'number')
//             )} */}
//             {item?.label}
//           </p>
//         ),
//         enableSorting: true,
//         sortingFn: 'NA',
//         cell: value => {
//           const v =
//             typeof value?.getValue() == 'object'
//               ? value?.getValue()?.[JSON.parse(item?.display_options)?.[0]]
//               : value?.getValue()
//           return changeValueFormat(v, moduleType === 'reason_master' && item?.type === 'varchar' ? 'text' : item?.type, { moduleType })
//         }
//       })
//     })
// }

import { createColumnHelper } from "@tanstack/react-table";
import { changeValueFormat } from "./format.utils";

const columnHelper = createColumnHelper();

/*
 * this function is used to generate the headers
 * @props
 * data: contains the array of object with the keys of [name, key, type]
 */
export const generateReportHeaders = (data, moduleType) => {
  if (!data?.length) return [];

  const visibleData = data.filter((item) => !item?.hidden);

  const formatCell = (item) => (value) => {
    const raw = value?.getValue();

    let v;

    // ARRAY → use as-is
    if (Array.isArray(raw)) {
      v = raw;
    }
    // OBJECT → extract display field
    else if (raw && typeof raw === "object") {
      const displayKey = JSON.parse(item?.display_options || "[]")?.[0];
      v = displayKey ? raw[displayKey] : raw;
    }
    // PRIMITIVE
    else {
      v = raw;
    }

    return changeValueFormat(v, item?.type, { moduleType, item });
  };

  const result = [];
  let i = 0;

  while (i < visibleData.length) {
    const col = visibleData[i];

    // ---- CASE 1: merged (subheader) columns ----
    if (col.is_merge_column && col.merge_header) {
      const mergeHeader = col.merge_header;
      const groupCols = [];

      while (
        i < visibleData.length &&
        visibleData[i].merge_header === mergeHeader
      ) {
        groupCols.push(visibleData[i]);
        i++;
      }

      result.push({
        header: mergeHeader,
        columns: groupCols.map((item) =>
          columnHelper.accessor(item?.field, {
            header: item?.label,
            id: item?.id,
            enableSorting: true,
            sortingFn: "NA",
            interface: item?.interface,
            special: item?.special,
            cell: formatCell(item),
          })
        ),
      });
    } else {
      // ---- CASE 2: normal column (your old logic) ----
      result.push(
        columnHelper.accessor(col?.field, {
          header: ({ table }) => (
            <p
              style={{
                textAlign:
                  moduleType === "report" &&
                  table.options.data?.some(
                    (i) => typeof i?.[col?.field] === "number"
                  )
                    ? "left"
                    : "left",
                width:
                  moduleType === "report" &&
                  table.options.data?.some(
                    (i) => typeof i?.[col?.field] === "number"
                  ) &&
                  100,
                whiteSpace:
                  moduleType === "report" &&
                  table.options.data?.some(
                    (i) => typeof i?.[col?.field] === "number"
                  ) &&
                  "wrap",
              }}
            >
              {col?.label}
            </p>
          ),
          enableSorting: true,
          interface: col?.interface,
          sortingFn: "NA",
          special: col?.special,
          cell: formatCell(col),
        })
      );
      i++;
    }
  }

  return result;
};
